import React from 'react';
import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer';
import HeroSection from '../../components/common/HeroSection';
import FeaturesSection from './FeaturesSection';
import BenefitsGrid from './BenefitsGrid';
import MarketApplications from './MarketApplications';
import AchievementSection from './AchievementSection';
import PartnersSection from './PartnersSection';
import ResourcesSection from './ResourcesSection';
import SEO from '../../components/common/SEO';
import { useNavigate } from 'react-router-dom';
import StayConnected from './StayConnected';

const HomePage = () => {
  const navigate = useNavigate();
  const handleShopNow = () => {
    navigate('/shop');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const handleDiscoverElixir = () => {
    navigate('/about');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen flex flex-col">
      <SEO
        title="Home"
        description="Discover Elixir, the Mediterranean's liquid gold. Premium honey varieties from Tunisia's sun-drenched lands, crafted with traditional methods and presented with unparalleled elegance. Experience the art of honey, elevated."
        keywords="
          Mediterranean honey,
          premium honey varieties,
          Tunisian honey,
          organic honey,
          luxury honey,
          artisanal honey,
          natural honey,
          health benefits of honey,
          gourmet honey,
          traditional beekeeping
        "
      />
      <Header />
      <main className="flex-grow">
        <HeroSection
          title="Elixir: The Mediterranean's Liquid Gold"
          description="A Symphony of Senses. A Statement of Style"
          primaryCTA={{
            text: 'Shop Now',
            onClick: handleShopNow,
          }}
          secondaryCTA={{
            text: 'Discover Elixir',
            onClick: handleDiscoverElixir,
          }}
        />
        <BenefitsGrid />
        <FeaturesSection />
        <MarketApplications />
        <AchievementSection />
        <PartnersSection />
        <ResourcesSection />
        <StayConnected />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
